import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default function useFeedbackPointEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { route, router } = useRouter()
  const { getItem, updateItem, getItems } = useLambda()
  const feedbackPoint = ref({})
  const isSubmitting = ref(false)
  const query = { _id: oid(route.value.params.id) }
  const collection = 'feedback_point'

  const show = async () => {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })
      if (!item) throw new Error('Item not found')

      item.physical_location = item.physical_location?.toString() || null
      item.location = item.location?.toString() || null
      feedbackPoint.value = item
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.feedbackPoint_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async data => {
    isSubmitting.value = true

    try {
      const action = { $set: { 
        name: data.name?.value || '',
        physical_location: data.physical_location?.value ? oid(data.physical_location.value) : null,
        location: data.location?.value ? oid(data.location.value) : null,
      }}

      await updateItem({ collection, query, action })

      showSuccessMessage(i18n.t('message.feedbackPoint_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.feedbackPoint_update_error'))
    } finally {
      router.push({ name: 'organization-feedbackPoint-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    feedbackPoint,
    isSubmitting,
  }
}
